
























import Vue from 'vue';
import Component from 'vue-class-component';
import store from '@/store';
import {Watch} from 'vue-property-decorator';

@Component

export default class OptionsTemplate extends Vue {
    useDarkTheme: boolean = (this.$vuetify.theme.dark = store.state.theme.dark);

    @Watch('useDarkTheme') onUseDarkThemeChanged() {
        store.commit('toggleDarkTheme');
    }
}
